// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

const isNestedEcommerceEventProperty = objectOf({
  name: string,
  type: string,
  monetary: maybe(boolean),
});

export const isEcommerceEventPropertiesResponse = objectOf({
  properties: arrayOf(
    objectOf({
      name: string,
      type: string,
      monetary: maybe(boolean),
      properties: maybe(arrayOf(isNestedEcommerceEventProperty)),
    })
  ),
});
